/**
 * Displays the current page title and the selected time period
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './header.css';

export default class SubHeader extends Component {
  static propTypes = {
    title: PropTypes.string,
    timePeriod: PropTypes.string
  };
  render() {
    const { title, timePeriod } = this.props;
    return (
      <div className="pure-g">
        <div className="pure-u-1 u-c">
          <h1 className={styles.subHeader}>
            {title} <span className={styles.separator}>|</span> {timePeriod.toUpperCase()}
          </h1>
        </div>
      </div>
    );
  }
}
